export const initialState = {
  contacts: {
    items: [],
    isLoading: false,
    error: null,
  },
  filters: '',
};
